import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ScriptService} from 'ngx-script-loader';
import {switchMap} from 'rxjs/operators';
import * as L from 'leaflet';
import {icon, LatLngLiteral} from 'leaflet';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

declare function windyInit(options, callback);

@Injectable()
export class MapService {
  private map: L.Map;

  constructor(
    private windyScriptLoaderService: ScriptService,
    private httpClient: HttpClient) {
  }

  getRoutes(mapName: string) {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/get-routes?mapName=' + mapName);
  }

  initializeWindyMap(windyApiKey: string, lat: number, lon: number, zoom: number): Observable<void> {
    if (this.map) {
      this.updateMapCenter(lat, lon, zoom);
      return of();
    } else {
      const options = {
        key: windyApiKey,
        verbose: true,
        lat,
        lon,
        zoom,
      };
      return this.windyScriptLoaderService.loadScript('https://api.windy.com/assets/map-forecast/libBoot.js').pipe(
        switchMap(() => {
          return new Observable<void>(observer => {
            windyInit(options, windyAPI => {
              this.map = windyAPI.map;
              if (environment.apiProdKeyWindy !== '') {
                windyAPI.store.set('overlay', 'rain').catch(() => {});
              }
              observer.next();
              observer.complete();
            });
          });
        })
      );
    }
  }

  clearMap(): void {
    this.map = null;
  }

  updateMapCenter(lat: number, lon: number, zoom: number): void {
    if (this.map) {
      this.map.setView([lat, lon], zoom);
    }
  }

  addTrajectoryLine(startPoint: L.LatLngLiteral, endPoint: L.LatLngLiteral, color: string) {
    if (this.map) {
      L.polyline([startPoint, endPoint], {color}).addTo(this.map);
    }
  }

  addMarker(markerPoint: LatLngLiteral) {
    const markerIcon = icon({
      iconUrl: 'assets/images/icons/marker1.png', iconSize: [40, 40], iconAnchor: [16, 32], popupAnchor: [0, -32],
    });
    L.marker(markerPoint, {icon: markerIcon}).addTo(this.map);
  }
}
